export const getCategoriaEmpresa = (numEmpleados) => {
  if (numEmpleados <= 10) {
    return 0; // Índice para Microempresa
  } else if (numEmpleados <= 50) {
    return 1; // Índice para Pequeña empresa
  } else if (numEmpleados <= 200) {
    return 2; // Índice para Mediana empresa
  } else {
    return 3; // Índice para Grande empresa
  }
};
